<template>
  <div class="home">
    <div class="header">
      <div class="logo">
        <img :src="siteConfig.logo" alt="" srcset="">
      </div>
      <div class="left" @click="search">
        <i class="search-icon" v-html="SearchIcon" />
        <span>输入关键词查找片源</span>
      </div>
      <div class="hot-clock" @click="$router.push('/history')">
        <img src="@assets/imgs/public/hot-clock.png" alt="" class="logo" />
      </div>
    </div>
    <div class="labels">
      <div class="tab" v-if="homeClass.length > 0">
        <md-tabs :ink-length="50" v-model="selectClassKey" @change="selectLabels">
          <md-tab-pane v-for="(item, index) in homeClass" :key="index" :label="item.name" :name="item.id + ''" />
        </md-tabs>
      </div>
      <div class="menu" @click="isShowPoup = true">
        <img src="@assets/imgs/public/menu.png" alt=""/>
      </div>
    </div>
    <div class="main">
      <keep-alive>
        <long-video v-if="selectKey === 0" :selectClassKey="selectClassKey" :isShowPoup="isShowPoup" @closePoup="closePoup"/>
      </keep-alive>
    </div>
    <HotSkeleton v-if="isShowSkeleton"/>
    <CustomBtn />
    <LimitNum />
  </div>
</template>

<script>
import { Tabs, TabPane } from 'mand-mobile';
// import ShortVideo from './components/shortVideo';
import LongVideo from './components/longVideo';
import { SearchIcon } from '@assets/svgs';
// import LangSelector from '@components/langSelector';
// import HomeNovel from '@views/home/home/components/novel';
import { getHomeClass } from '@api/longVideo';
import HotSkeleton from '@/components/Skeleton/hotSkeleton.vue';
import CustomBtn from '@/components/CustomBtn/index.vue';
import LimitNum from '@components/LimitNum/index.vue';

export default {
  name: 'Hot',
  components: {
    // HomeNovel,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    // ShortVideo,
    LongVideo,
    HotSkeleton,
    CustomBtn,
    LimitNum
    // LangSelector
  },
  data () {
    return {
      isShowSkeleton: true,
      isShowPoup: false,
      selectKey: 0,
      selectClassKey: '0',
      isShowSelect: false,
      isShowMenu: false,
      countDownTime: 3,
      refreshKey: 0,
      SearchIcon,
      homeClass: [],
      selectClassItem: {}
    };
  },
  computed: {
    ...mapState('home', ['hasShowLaunch', 'nation']),
    ...mapState('user', ['token', 'freeWatch', 'userInfo'])
  },
  beforeDestroy () {
    clearInterval(this.countDownTimer);
  },
  watch: {
    token () {
      this.refreshKey++;
    },
    nation () {
      console.log('natin change');
      this.refreshKey++;
    },
    freeWatch: {
      handler (val) {
        // 观看次数为0且不是会员
        if (val <= 0 && this.userInfo?.is_vip === 0) {
          this.setIsShowLimitNum(true);
        }
      },
      immediate: true
    }
  },
  activated () {
    const selectKey = this.$route.query.selectKey;
    if (selectKey) {
      this.selectKey = Number(selectKey);
    }
  },
  created () {
    this.getHomeClass();
    this.getFreeWatchCountFn();
    this.initAfterChangeLang([this.getHomeClass]);
  },
  mounted () {
    const selectKey = this.$route.query.selectKey;
    if (selectKey) {
      this.selectKey = Number(selectKey);
    }
    this.$bus.$on('', () => this.refreshKey++);
  },
  methods: {
    ...mapMutations('home', ['setHasShowLaunch']),
    ...mapActions('user', ['getFreeWatchCountFn']),
    ...mapMutations('publicStore', ['setLoadingShowFlag', 'setIsShowLimitNum']),
    closePoup (selected) {
      this.selectClassKey = selected;
      this.isShowPoup = false;
    },
    select (key) {
      if (this.selectKey === key && key === 1) {
        this.$bus.$emit('afterChangeLanguage', { isOnlyHomeShortVideo: true });

        this.setLoadingShowFlag(true);
        setTimeout(() => {
          this.setLoadingShowFlag(false);
        }, 500);
      }
      this.selectKey = key;
      this.isShowMenu = false;
    },
    getHomeClass () {
      getHomeClass().then(res => {
        if (res.result === 200000) {
          this.isShowSkeleton = false;
          this.homeClass = res.data.list;
          this.homeClass.forEach((item, index) => {
            // console.log('1111', index);
            item.page = 1;
            item.pageCount = 0;
          });
          this.selectClassKey = this.homeClass[0].id + '';
          this.selectClassItem = this.homeClass[0];
        }
      });
    },
    selectLabels (val) {
      this.selectClassKey = val.name + '';
      this.selectClassItem = val;
    },
    chooseMenu (key) {
      if (key === 'nation') {
        // this.$toast.info(this.$t('homeNoOpenNet'));
        this.isShowSelect = true;
      } else if (key === 'app') {
        this.download();
      } else if (key === 'qrcode') {
        this.$router.push('/myQrcode');
      }
      this.toggleMenu();
    },
    toggleMenu () {
      this.isShowMenu = !this.isShowMenu;
    },
    launchPageFlag () {
      this.setHasShowLaunch(true);
    },
    countDown () {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
      this.countDownTimer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime--;
        } else {
          clearInterval(this.countDownTimer);
          this.countDownTimer = null;
        }
      }, 1000);
    },
    shorVideoSearch () {
      this.$router.push('/shorVideoSearch');
    },
    download () {
      this.$router.push('/download');
    },
    search (type = 'search') {
      // 带着当前选择标签参数跳转
      if (type === 'menu') {
        this.$router.push('/longVideoSearch?selectKey=' + this.selectClassKey);
      } else {
        this.$router.push('/longVideoSearch');
      }
      // if (this.selectKey === 0) {
      //   this.$router.push('/longVideoSearch');
      // } else if (this.selectKey === 1) {
      //   this.shorVideoSearch();
      // } else if (this.selectKey === 2) {
      //   this.$router.push('/novel/search');
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  //height: calc(100% - 50px);
  height: 100%;
  background-color: #070709;

  .header {
    //position: fixed;
    //top: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding: 0 16px;
    gap: 10px;
    .logo {
      img {
        width: 88px;
        //height: 27px;
      }
    }
    .left {
      flex: 1;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.12);
      display: flex;
      align-items: center;
      padding: 3px 0;
      span {
        color: rgba(255, 255, 255, 0.4);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
      }
      .search-icon {
        //position: absolute;
        //top: 0;
        //left: 10px;
        //right: 16px;
        //background-image: url("~@assets/imgs/public/searchIcon.png");
        margin: 0 10px;
      }
    }

    i {
      width: 24px;
      height: 24px;
      background-size: 100% 100%;
    }
    .hot-clock {
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }

/*    .logo {
      position: absolute;
      top: 18px;
      right: 4px;
      width: 89px;
      height: 30px;
      background: url("assets/logo.png") 0 0/100% 100%;
    }*/

    .first-menu {
      position: absolute;
      top: 18px;
      left: 16px;
      width: 22px;

      .add {
        width: 22px;
        height: 22px;
        background: url("./assets/addIcon.png") 0 0/100% 100%;
      }

      .second-menu {
        position: relative;
        top: 6px;
        left: -3px;
        width: 150px;
        //padding: 0 10px;
        height: 0;
        overflow: hidden;
        background: #FFF;
        border-radius: 6px;
        transition: all 0.15s ease-out;

        &.isZh {
          width: 116px;
        }

        &.show140 {
          height: 140px;
          overflow: unset;

          .item {
            opacity: 1;
          }
        }

        &.show93 {
          height: 93px;
          overflow: unset;

          .item {
            opacity: 1;
          }
        }

        &:before {
          content: '';
          position: absolute;
          top: -12px;
          left: 6px;
          display: block;
          border-style: solid;
          border-top-width: 6px;
          border-bottom-width: 6px;
          border-left-width: 8px;
          border-right-width: 8px;
          border-top-color: transparent;
          border-bottom-color: #FFF;
          border-left-color: transparent;
          border-right-color: transparent;
        }

        .item {
          display: flex;
          align-items: center;
          height: 46px;
          opacity: 0;
          transition: all 0.2s ease-out;

          img {
            width: 22px;
            height: 22px;
            margin-right: 7px;
            margin-left: 10px;
          }

          span {
            font-family: 'PingFang SC';
            font-weight: 500;
            font-size: 13px;
            line-height: 13px;
            color: rgba(22, 22, 22, 0.9);
          }
        }
      }
    }
  }

  .main {
    //height: 100%;
    height: calc(100% - 50px);
  }

  .launch-page {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;

    .count-down {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      font-size: 18px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-weight: 500;
      text-space: 3px;
      //background-color: lightslategray;
      color: #FFF;
    }

    .enter {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: #FFF;
    }
  }
  .labels {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    height: 24px;
    margin: 10px 0;
    // mand mobile 不支持滚动
    overflow-x: auto;
    white-space: nowrap;
    .menu {
      width: 24px;
      height: 24px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .tab {
      width: 90%;
      display: flex;
      /deep/.md-tabs {
        width: 100%;
        .md-tab-bar {
          height: 24px;
          background: transparent;
          color: #FFFFFF80;
          font-size: 12px;
          font-weight: 400;
          font-family: PingFang SC;
          padding: 0;
          .md-tab-bar-list {
            max-width: fit-content;
            min-width: fit-content;
          }
          .md-tab-bar-ink {
            background:  #E7992A;
            height: 1px;
            padding: 0 10px;
            bottom: 0!important;
          }
        }
        .md-tab-bar-item {
          min-height: 24px;
          max-height: 24px;
          padding: 0 10px;
          color: #FFFFFF80;
          font-size: 15px;
          font-weight: 400;
          font-family: PingFang SC;
          &.is-active {
            color: #FFFFFF;
            top: -3px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.search-icon {
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>
